export class Assignment {
  sLoanAssistant: string;
  sLoanOfficer: string;
  sLoanProcessor: string;
  sLoanUnderwriter: string;
  sCloser: string;
  sFunder: string;
  sPostCloser: string;
}
